var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { MessageType } from "../../models/message-type";
import { ViewType } from "../../models/view-type";
import { Base } from "../base";
import { Message } from "./message";
var ChatArea = /** @class */ (function (_super) {
    __extends(ChatArea, _super);
    function ChatArea(configuration, viewType, parseMarkdownAction) {
        var _this = _super.call(this) || this;
        _this.addAssistantMessage = function (text, viewType) { return __awaiter(_this, void 0, void 0, function () {
            var parsedText, index, source, addAssistantMessage;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._parseMarkdownAction(text)];
                    case 1:
                        parsedText = _a.sent();
                        index = this.getMessageIndex(MessageType.Assistant);
                        source = this._configuration.chatbotAvatarImage;
                        if (!source || source.length === 0) {
                            source = "data:image/svg+xml;base64, ".concat(process.env.AIGO_DEFAULT_BOT_AVATAR);
                        }
                        addAssistantMessage = new Message(index, MessageType.Assistant, source, 29, 40, parsedText, this._configuration.assistantResponseBackgroundColor, this._configuration.assistantResponseFontColor, this._viewType);
                        this._messages.push(addAssistantMessage);
                        this.self.appendChild(addAssistantMessage.self);
                        return [2 /*return*/];
                }
            });
        }); };
        _this.addUserMessage = function (text, viewType) { return __awaiter(_this, void 0, void 0, function () {
            var parsedText, index, source, addUserMessage;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._parseMarkdownAction(text)];
                    case 1:
                        parsedText = _a.sent();
                        index = this.getMessageIndex(MessageType.User);
                        source = this._configuration.userAvatarImage;
                        if (!source || source.length === 0) {
                            source = null; // default user avatar
                        }
                        addUserMessage = new Message(index, MessageType.User, source, 24, 24, parsedText, this._configuration.userQuestionBackgroundColor, this._configuration.userQuestionFontColor, this._viewType);
                        this._messages.push(addUserMessage);
                        this.self.appendChild(addUserMessage.self);
                        return [2 /*return*/];
                }
            });
        }); };
        _this.addEmptyAssistantMessage = function (viewType) { return __awaiter(_this, void 0, void 0, function () {
            var index, source, addAssistantMessage;
            return __generator(this, function (_a) {
                index = this.getMessageIndex(MessageType.Assistant);
                source = this._configuration.chatbotAvatarImage;
                if (!source || source.length === 0) {
                    source = "data:image/svg+xml;base64, ".concat(process.env.AIGO_DEFAULT_BOT_AVATAR);
                }
                addAssistantMessage = new Message(index, MessageType.Assistant, source, 29, 40, null, this._configuration.assistantResponseBackgroundColor, this._configuration.assistantResponseFontColor, this._viewType);
                this._messages.push(addAssistantMessage);
                this.self.appendChild(addAssistantMessage.self);
                this.revealMessage(addAssistantMessage.self);
                return [2 /*return*/];
            });
        }); };
        _this.addTextToLastAssistantMessage = function (text, viewType) { return __awaiter(_this, void 0, void 0, function () {
            var parsedText, lastMessage;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._parseMarkdownAction(text)];
                    case 1:
                        parsedText = _a.sent();
                        lastMessage = this._messages[this._messages.length - 1];
                        lastMessage.replaceText(parsedText);
                        this.revealMessage(lastMessage.self);
                        return [2 /*return*/];
                }
            });
        }); };
        _this.scrollToBottom = function () {
            _this.self.scrollTop = _this.self.scrollHeight;
        };
        _this.setSmallSizeWindow = function () {
            _this._viewType = ViewType.DesktopSmall;
            _this.self.style.width = '350px';
            var height = _this.calculateHeightForDesktopSmall();
            _this.self.style.height = height;
            _this.self.style.maxHeight = height;
            _this._messages.forEach(function (message) {
                message.minimizeWindow();
            });
        };
        _this.setFullSizeWindow = function (viewType) {
            if (viewType === void 0) { viewType = _this._viewType; }
            _this._viewType = viewType;
            _this.self.style.width = '100%';
            if (_this._viewType === ViewType.MobileSmall || _this._viewType === ViewType.MobileLarge) {
                _this.self.style.minHeight = '0';
                _this.self.style.flex = '1 1 auto';
            }
            else {
                var height = _this.calculateHeightForDesktop();
                _this.self.style.height = height;
                _this.self.style.maxHeight = height;
            }
            _this._messages.forEach(function (message) {
                message.maximizeWindow(viewType);
            });
        };
        _this.calculateHeightForDesktopSmall = function () {
            var maxHeight = 400;
            var minHeight = 100;
            var reservedHeight = 320;
            return Math.min(maxHeight, Math.max(minHeight, window.innerHeight - reservedHeight)) + 'px';
        };
        _this.calculateHeightForDesktop = function () {
            var inputHeight = 40;
            var footer = 60;
            var closeIcon = 70;
            var margins = 144;
            return (window.innerHeight - (inputHeight + footer + closeIcon + margins)) + 'px';
        };
        _this.getMessageIndex = function (messageType) {
            return _this._messages.filter(function (message) { return message.type === messageType; }).length;
        };
        _this.revealMessage = function (message) {
            var chatArea = _this.self;
            var chatAreaRect = chatArea.getBoundingClientRect();
            var messageRect = message.getBoundingClientRect();
            var messageTop = chatArea.scrollTop + messageRect.top - chatAreaRect.top;
            var targetScrollTop = messageRect.height > chatArea.clientHeight
                ? messageTop
                : chatArea.scrollHeight;
            chatArea.scrollTo({
                top: Math.max(0, targetScrollTop),
                behavior: 'smooth'
            });
        };
        _this.addScrollbarStyles = function (chatArea, backgroundColor, color) {
            chatArea.insertAdjacentHTML('beforeend', "\n            <style type=\"text/css\">\n                #js_aigo_bot_chat_area::-webkit-scrollbar {\n                    width: 4px;\n                }\n                \n                #js_aigo_bot_chat_area::-webkit-scrollbar-track {\n                    background-color: ".concat(backgroundColor, ";\n                    border-radius: 5px;\n                }\n                \n                #js_aigo_bot_chat_area::-webkit-scrollbar-thumb {\n                    background-color: ").concat(color, ";\n                    border-radius: 5px;\n                }\n            </style>\n        "));
        };
        _this._configuration = configuration;
        _this._messages = [];
        _this._parseMarkdownAction = parseMarkdownAction;
        _this._viewType = viewType;
        var chatArea = document.createElement('div');
        chatArea.id = 'js_aigo_bot_chat_area';
        chatArea.style.backgroundColor = configuration.chatHistoryBackgroundColor;
        chatArea.style.minHeight = '100px';
        chatArea.style.borderRadius = '5px';
        chatArea.style.overflowX = 'hidden';
        chatArea.style.overflowY = 'auto';
        chatArea.style.paddingBottom = '10px';
        chatArea.style.display = 'flex';
        chatArea.style.flexDirection = 'column';
        _this.addScrollbarStyles(chatArea, configuration.sliderBackgroundColor, configuration.sliderColor);
        _this.self = chatArea;
        if (viewType === ViewType.DesktopSmall) {
            _this.setSmallSizeWindow();
        }
        else {
            _this.setFullSizeWindow();
        }
        _this.addAssistantMessage(configuration.assistantResponseText, viewType);
        return _this;
    }
    return ChatArea;
}(Base));
export { ChatArea };
